// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD_XQn2NUbDEOm1MIVvub5EVHWWGVAGo1M",
    authDomain: "makaw-3a1bf.firebaseapp.com",
    databaseURL: "https://makaw-3a1bf.firebaseio.com",
    projectId: "makaw-3a1bf",
    storageBucket: "makaw-3a1bf.appspot.com",
    messagingSenderId: "421472079378",
    appId: "1:421472079378:web:a25b0c56d3f8f6450312cb",
    measurementId: "G-ZBB3V56ND0"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
